import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { fetchTopicPinnedKnowledgeFulfilled, fetchTopicPinnedKnowledgeRejected } from "domains/pinAddReject/actions";
import type { FetchTopicPinnedKnowledge } from "domains/pinAddReject/actionTypes";
import type { KnowledgeResponse } from "entities/knowledge/types";

export function* fetchTopicPinnedKnowledgeSaga(action: FetchTopicPinnedKnowledge) {
  const { limit, page } = action.meta;

  const offset = page && limit ? (page - 1) * limit : undefined;

  try {
    const data: KnowledgeResponse[] = yield apiFetch(`topic/${action.meta.topicId}/knowledge`, {
      method: "GET",
      queryParams: {
        pinned: true,
        limit,
        offset,
      },
      ...(action.meta.forceRefresh
        ? {
            headers: {
              "Cache-Control": "no-cache, no-store, must-revalidate",
            },
          }
        : {}),
    });
    yield put(
      fetchTopicPinnedKnowledgeFulfilled(
        {
          topicId: action.meta.topicId,
          page: action.meta.page,
          limit: action.meta.limit,
        },
        { data },
      ),
    );
  } catch (error) {
    logger.error("[fetchTopicPinnedKnowledgeSaga] Error occurred while fetching pinned knowledge", error);
    yield put(
      fetchTopicPinnedKnowledgeRejected({
        topicId: action.meta.topicId,
        page: action.meta.page,
        limit: action.meta.limit,
      }),
    );
  }
}
